module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-bottom-backplates.5cafc8a5.png";